import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { AuthShell } from './AuthShell';
import { Button, Field, Input } from './ui';

interface RegisterProps {
  onToggleMode: () => void;
}

export const Register: React.FC<RegisterProps> = ({ onToggleMode }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const { register } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      setIsLoading(false);
      return;
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters long');
      setIsLoading(false);
      return;
    }

    try {
      await register(email, password, name);
    } catch (err: any) {
      setError(err.message || 'Registration failed');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthShell
      title="Create your account"
      subhead="Tracks income, expenses, cards, loans and projected balance."
      error={error}
      footer={
        <p className="text-[13.5px] text-ink-soft">
          Already have an account?{' '}
          <button
            type="button"
            onClick={onToggleMode}
            className="text-accent hover:text-accent-press transition-colors duration-[120ms]"
          >
            Sign in
          </button>
        </p>
      }
    >
      <form onSubmit={handleSubmit} className="space-y-6">
        <Field label="Name" hint="Optional." htmlFor="reg-name">
          <Input
            id="reg-name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Your name"
          />
        </Field>

        <Field label="Email" htmlFor="reg-email">
          <Input
            id="reg-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your.email@example.com"
          />
        </Field>

        <Field label="Password" hint="At least 6 characters." htmlFor="reg-password">
          <Input
            id="reg-password"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="At least 6 characters"
          />
        </Field>

        <Field label="Confirm password" htmlFor="reg-confirm">
          <Input
            id="reg-confirm"
            type="password"
            required
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Confirm your password"
          />
        </Field>

        <div className="flex justify-end pt-1">
          <Button type="submit" variant="primary" disabled={isLoading}>
            {isLoading ? 'Creating account…' : 'Create account'}
          </Button>
        </div>
      </form>
    </AuthShell>
  );
};
